module.exports = __webpack_public_path__ + "static/media/img1.c1a2fa81.jpg";